import type { Middleware } from 'openapi-fetch';

/**
 * The SPA holds no secrets and no long-lived credential: `core/auth` owns the OIDC session and
 * hands the SDK a function that returns the *current* access token. A token captured at client
 * construction would go stale on the first silent refresh, so the provider is called per request.
 *
 * It may be async: refresh-ahead-of-expiry happens inside the provider, not here.
 */
export type TokenProvider = () => string | null | undefined | Promise<string | null | undefined>;

export function createAuthMiddleware(tokenProvider: TokenProvider): Middleware {
  return {
    async onRequest({ request }) {
      if (request.headers.has('Authorization')) return undefined;
      const token = await tokenProvider();
      if (token === null || token === undefined || token === '') return undefined;
      request.headers.set('Authorization', `Bearer ${token}`);
      return request;
    },
  };
}
